export default __webpack_public_path__ + "static/media/Transfer.f40f5bfa.svg";